export const calculatePagesCount = (totalCount: number, pageSize: number): number => {
  return Math.ceil(totalCount / pageSize);
};

export const updatePageNumber = (totalCount: number, pageSize: number, pageNumber: number): number => {
  const pageCount = calculatePagesCount(totalCount, pageSize) - 1;
  return Math.min(pageCount, pageNumber);
};
